<template>
    <aside v-if="show" class="rounded-xl p-4 md:mx-8 text-white fixed top-8 left-0 md:left-64 right-0 z-50 shadow-lg bg-opacity-90" :class="type.background" ref="top_msg">
        <div class="flex items-stretch justify-between gap-4">
            <div class="flex-none flex items-center justify-center">
                <div class="text-lg rounded-full w-8 h-8 flex items-center justify-center" :class="type.background">
                    <span class="far" :class="type.icon"></span>
                </div>
            </div>
            <div class="flex-1 flex flex-col gap-2">
                <h3 v-if="type.text" class="text-sm font-bold">
                    {{ type.text }}
                </h3>
                <p v-if="typeof message.text === 'string'" class="text-sm">
                    {{ message.text }}
                </p>
                <ul v-else>
                    <li v-for="text in message.text">{{ text }}</li>
                </ul>
            </div>
            <button @click="clear" class="flex-none flex items-start focus:outline-none cursor-pointer">
                <i class="fa-solid fa-xmark fa-lg"></i>
            </button>
        </div>
    </aside>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useMessageStore } from "@/stores/message";

export default {
    name: "MessageDisplay",
    data() {
        return {
            types: [
                {
                    type: 'alert',
                    text: 'Alert',
                    background: 'bg-bhav-blue-500',
                    icon: 'fa-triangle-exclamation'
                },
                {
                    type: 'error',
                    text: 'Error',
                    background: 'bg-bhav-red-500',
                    icon: 'fa-circle-exclamation'
                },
                {
                    type: 'success',
                    text: 'Success',
                    background: 'bg-green',
                    icon: 'fa-circle-check'
                },
                {
                    type: 'message',
                    text: 'Message',
                    background: 'bg-bhav-blue-500',
                    icon: 'fa-circle-info'
                }
            ]
        }
    },
    computed: {
        ...mapState(useMessageStore, ['show', 'message']),
        type() {
            return this.types.find(type => type.type == (this.message?.level || 'error'));   
        },
    },
    methods: {
        ...mapActions(useMessageStore, ['clear'])
    },
    watch: {
        'show': {
            handler(newValue) {
                if (newValue) {
                    setTimeout(() => {
                        const element = this.$refs.top_message;
                        if (element) {
                            element.scrollIntoView({ behavior: 'smooth' });
                        }
                    }, 100);
                }
            },
            immediate: true
        }
    },
};
</script>